"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get WorkerPool () {
        return WorkerPool;
    },
    get WorkerPoolEvents () {
        return WorkerPoolEvents;
    }
});
const _events = require("events");
const _ThreadWorker = require("./ThreadWorker.js");
const _pickTaskFromQueue = require("./pickTaskFromQueue.js");
const _os = /*#__PURE__*/ _interop_require_default(require("os"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const WorkerPoolEvents = {
    freedWorker: "freedWorker",
    idle: "idle",
    busy: "busy",
    restarting: "restarting"
};
class WorkerPool extends _events.EventEmitter {
    isIdle() {
        return this.workers.every((w)=>w.status === "free");
    }
    get workerRestarts() {
        return this.workers.reduce((acc, worker)=>acc + worker.restarts, 0);
    }
    get maxWorkerMemoryUsage() {
        return this.workers.reduce((acc, worker)=>Math.max(acc, worker.maxWorkerMemoryUsage), 0);
    }
    stats() {
        return {
            maxWorkerMemoryUsage: this.maxWorkerMemoryUsage,
            workerRestarts: this.workerRestarts
        };
    }
    createInitialWorkers() {
        if (this.workers.length === 0) {
            for(let i = 0; i < this.minWorkers; i++){
                this.addNewWorker();
            }
        }
    }
    addNewWorker() {
        if (this.workers.length <= this.maxWorkers) {
            const { script, workerOptions } = this.options;
            const worker = new _ThreadWorker.ThreadWorker(script, {
                workerOptions,
                workerIdleMemoryLimit: this.options.workerIdleMemoryLimit
            });
            worker.on("free", (data)=>{
                const { weight } = data;
                this.availability += weight;
                this.emit(WorkerPoolEvents.freedWorker);
            });
            this.workers.push(worker);
            return worker;
        }
    }
    exec(task, weight, setup, cleanup, abortSignal, priority) {
        if (abortSignal?.aborted) {
            return Promise.resolve();
        }
        // cull the weight of the task to be [1, maxWorkers]
        weight = Math.min(Math.max(1, weight), this.maxWorkers);
        return new Promise((resolve, reject)=>{
            this.queue.push({
                task: {
                    ...task,
                    weight
                },
                weight,
                resolve,
                reject,
                cleanup,
                setup,
                priority
            });
            this._exec(abortSignal);
        });
    }
    _exec(abortSignal) {
        // find work that will fit the availability of workers
        const workIndex = (0, _pickTaskFromQueue.pickTaskFromQueue)(this.queue, this.availability);
        if (workIndex === -1) {
            return;
        }
        // This is to immediate execute tasks if there ARE free workers
        // If there are no free workers, the "workerFreedEvent" will call this function again to start the task
        let worker = this.workers.find((w)=>w.status === "free");
        // If there are no free workers, create a new one
        if (!worker) {
            worker = this.addNewWorker();
        }
        if (worker) {
            const work = this.queue[workIndex];
            this.queue.splice(workIndex, 1);
            this.availability -= work.weight;
            worker.start(work, abortSignal);
        }
    }
    async close() {
        await Promise.all(this.workers.map((worker)=>worker.terminate()));
    }
    constructor(options){
        super(), _define_property(this, "options", void 0), _define_property(this, "workers", void 0), _define_property(this, "freeWorkers", void 0), _define_property(this, "queue", void 0), _define_property(this, "minWorkers", void 0), _define_property(this, "maxWorkers", void 0), _define_property(this, "availability", void 0), this.options = options, this.workers = [], this.freeWorkers = [], this.queue = [], this.minWorkers = 0, this.maxWorkers = 0, this.availability = 0;
        this.minWorkers = this.options.minWorkers ?? 2;
        this.maxWorkers = this.options.maxWorkers ?? _os.default.cpus().length - 1;
        this.availability = this.maxWorkers;
        this.workers = [];
        this.freeWorkers = [];
        this.queue = [];
        this.createInitialWorkers();
        // Any time the workerFreedEvent is emitted, dispatch
        // the next task pending in the queue, if any.
        this.on(WorkerPoolEvents.freedWorker, ()=>{
            if (this.queue.length > 0) {
                this._exec();
                this.emit(WorkerPoolEvents.busy);
            } else if (this.isIdle()) {
                this.emit(WorkerPoolEvents.idle);
            }
        });
    }
}
